import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  tableCellClasses,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Paper,
  Tooltip,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Colors from "assets/Style/Colors";
import {
  FontFamily,
  SearchIcon,
} from "assets";
import InputField from "components/Input";
import {
  Edit,
} from "@mui/icons-material";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import { makeStyles } from "@mui/styles";
import styled from "@emotion/styled";
import { useForm } from "react-hook-form";
import moment from "moment";
import { useNavigate } from "react-router-dom";


import Pagination from "components/Pagination";
import { useAuth } from "context/UseContext";
import BuyerServices from "services/Buyer";
import { FiDownload } from "react-icons/fi";


// *For Table Style

const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    padding: "15px",
    textAlign: "center",
    whiteSpace: "normal",
    verticalAlign: "top",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    // textWrap: "nowrap",
    verticalAlign: "middle",
    whiteSpace: "normal",
    maxWidth: "200px",
    wordBreak: "break-word",
    padding: "3px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "3px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "5px",
      width: "24px",
      height: "24px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function CompanyList() {
  const classes = useStyles();
  const navigate = useNavigate();
  const contentRef = useRef(null);
  const { user } = useAuth();
  const tableHead = [
    "Full Entity Name",
    "Short Name",
    "Expiry Date",
    "Owner",
    "ID Type",
    "ID Expiry Date",
    "E-mail",
    "Auction House",
    "Master ID",
    "Remarks",
    "Status",
    "Attachment",
    "Action",
  ];

  // *For Client Dropdown
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectCostingId, setSelectCostingId] = useState(false);
  const [checkedItems, setCheckedItems] = useState({
    shipping: false,
    storage: false,
    custom_vat: false,
  });
  const [openReverseModal, setOpenReverseModal] = useState(false);
  const [selectedRefId, setSelectedRefId] = useState(0);
  const [activeMenu, setActiveMenu] = useState(true);
  const [permissions, setPermissions] = useState();

  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reverseData, setReverseData] = useState({ notes: "" });

  //* ForLoader
  const [loader, setLoader] = useState(false);

  // *For Filters
  const [filters, setFilters] = useState({});

  const [companyData, setCompanyData] = useState([]);
  console.log(companyData, 'companyData')

  // *For Tooltip
  const [copied, setCopied] = useState(false);
  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const downloadAllAttachments = async (documentLinks) => {

    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split('.').pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl); // Cleanup
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  // put above return()
  const downloadAllDocs = async (docs = []) => {
    try {
      const links = docs
        ?.map(d => d?.document_link?.trim?.())
        ?.filter(Boolean);

      if (!links?.length) {
        ErrorToaster("No attachments available.");
        return;
      }

      for (const link of links) {

        await new Promise(res => setTimeout(res, 150));

        await downloadAllAttachments(link);
      }

      SuccessToaster("Downloading attachments...");
    } catch (e) {
      ErrorToaster("Failed to download one or more attachments.");
    }
  };



  const getCompanyData = async (page, limit, filter) => {
    setLoader(true);
    const Page = page ? page : currentPage;
    const Limit = limit ? limit : pageLimit;
    const Filter = { ...filters, ...filter };
    setCurrentPage(Page);
    setPageLimit(Limit);

    try {
      let params = {
        page: Page,
        limit: Limit,
      };
      params = { ...params, ...Filter };
      const { data } = await BuyerServices.getOrganizationData(params);
      setTotalCount(data?.count);
      setCompanyData(data?.rows);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  // *For Apply Filters
  const applyFilter = async () => {
    try {
      let data = {
        search: getValues("search"),
      };

      getCompanyData(1, "", data);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();


  useEffect(() => {
    getCompanyData();
  }, []);

  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null);
  };

  const getAuctionName = (id) => {
    if (!id) return null;
    const found = (companyData?.auction_houses || [])?.find?.(h => Number(h?.id) === Number(id));
    return found?.name || id;
  };

  const commaList = (arr = []) => {
    const cleaned = arr.filter(Boolean);
    return cleaned.length ? cleaned.join(", ") : "-";
  };

  const makeListStrings = (values = [], limit = 2) => {
    const cleaned = values.filter(Boolean);
    if (!cleaned.length) return { display: "-", full: "-", hasMore: false };
    const full = cleaned.join(", ");
    const display = cleaned.slice(0, limit).join(", ");
    return { display, full, hasMore: cleaned.length > limit };
  };

  const ListCell = ({ values = [], delimiter = ", " }) => {
    const cleaned = (values || [])
      .filter(v => v !== null && v !== undefined && String(v).trim() !== "");
    const full = cleaned.length ? cleaned.join(delimiter) : "-";

    if (full === "-") return <>-</>;

    return (
      <>
        <Tooltip className="pdf-hide" title={full} arrow placement="top">
          <span
            style={{
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "100%",
              minWidth: 0
            }}
          >
            {full}
          </span>
        </Tooltip>

        <span className="pdf-show" style={{ display: "none !important" }}>
          {full}
        </span>
      </>
    );
  };


  return (
    <Fragment>
      <Grid
        container
        spacing={1}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mr: 4,
              my: 4,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Company List
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          md={11}
        // component={"form"}
        // onSubmit={handleSubmit(applyFilter)}
        >
          <Box
            sx={{
              m: "10px 0 10px 0",
            }}
          >
            <Grid container spacing={1} alignItems={"center"}>
              <Grid item xs={3} md={3} sm={3}>
                <InputField
                  size={"small"}
                  label={"Search"}
                  placeholder={"Search"}
                  inputStyle={{ backgroundColor: "#f5f5f5" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  register={register("search", {
                    onChange: (e) => applyFilter({ search: e.target.value }),
                  })}

                />
              </Grid>
              {/* <Grid item xs={2} md={2}>
                <Box
                  sx={{
                    mt: "12px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <PrimaryButton type="submit" title="Search" />
                </Box>
              </Grid> */}
            </Grid>
          </Box>
        </Grid>

        <Grid item md={11}>
          <Box>
            {/* <PDFExport
            {/* <PDFExport
              ref={contentRef}
              landscape={true}
              paperSize="A4"
              margin={5}
              fileName="Paid/Unpaid Shipping Invoices"
            > */}
            <Box className="pdf-show" sx={{ display: "none" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="h5"
                  sx={{
                    color: Colors.charcoalGrey,
                    fontFamily: FontFamily.NunitoRegular,
                    mb: 2,
                  }}
                >
                  {/* Paid/Unpaid Shipping Invoices */}
                </Typography>
                <Box
                  sx={{
                    fontWeight: 400,
                    fontSize: "12px",
                    mt: 1.5,
                    color: Colors.charcoalGrey,
                  }}
                >
                  <span>Date: &nbsp;&nbsp;</span>
                  {moment().format("MM-DD-YYYY")}
                </Box>
              </Box>
            </Box>
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                borderRadius: 2,
                height:
                  companyData?.length < 2
                    ? "calc(100vh - 630px)"
                    : "calc(100vh - 330px)",
              }}
              className="table-box"
            >
              <Table stickyHeader sx={{ minWidth: 500 }}>
                <TableHead>
                  <Row>
                    {tableHead.map((cell, index) => (
                      <Cell className="pdf-table" key={index}>
                        {cell}
                      </Cell>
                    ))}
                  </Row>
                </TableHead>
                <TableBody>
                  {!loader ? (
                    companyData?.length > 0 ? (
                      <>
                        <Fragment>
                          {companyData?.map((item, index) => (
                            <Row
                              key={index}
                              sx={{
                                bgcolor: index % 2 !== 0 && "#EFF8E7",
                              }}
                            >
                              <Cell>{item?.full_e_name ?? '-'}</Cell>
                              <Cell>{item?.short_name ?? "-"}</Cell>
                              <Cell>{moment(item?.expiry_date).format("DD-MM-YYYY") ?? "-"}</Cell>
                              <Cell>{item?.owner ?? "-"}</Cell>
                              <Cell>
                                {Array.isArray(item?.id_types) && item.id_types.length ? (
                                  (() => {
                                    const types = item.id_types.map((doc) => doc?.type || "-");
                                    const display = types.slice(0, 2).join(", ");
                                    const hasMore = types.length > 2;

                                    return (
                                      <>
                                        <Tooltip
                                          className="pdf-hide"
                                          title={types.join(", ")}
                                          arrow
                                          placement="top"
                                          slotProps={{
                                            popper: {
                                              modifiers: [
                                                {
                                                  name: "offset",
                                                  options: { offset: [11, -2] },
                                                },
                                              ],
                                            },
                                          }}
                                        >
                                          <span>
                                            {hasMore ? `${display}...` : display}
                                          </span>
                                        </Tooltip>

                                        {/* For PDF export */}
                                        <Box
                                          component="div"
                                          className="pdf-show"
                                          sx={{ display: "none !important" }}
                                        >
                                          {types.join(", ")}
                                        </Box>
                                      </>
                                    );
                                  })()
                                ) : (
                                  "-"
                                )}
                              </Cell>

                              <Cell>
                                {Array.isArray(item?.id_types) && item.id_types.length ? (
                                  (() => {
                                    const dates = item.id_types.map((doc) =>
                                      doc?.expiry_date ? moment(doc.expiry_date).format("DD-MM-YYYY") : "-"
                                    );
                                    console.log(dates, 'dates')
                                    const display = dates.slice(0, 2).join(", ");
                                    const hasMore = dates.length > 2;

                                    return (
                                      <>
                                        <Tooltip
                                          className="pdf-hide"
                                          title={dates.join(", ")}
                                          arrow
                                          placement="top"
                                          slotProps={{
                                            popper: {
                                              modifiers: [
                                                {
                                                  name: "offset",
                                                  options: { offset: [10, -2] },
                                                },
                                              ],
                                            },
                                          }}
                                        >
                                          <span>
                                            {hasMore ? `${display}...` : display}
                                          </span>
                                        </Tooltip>

                                        {/* For PDF export */}
                                        <Box
                                          component="div"
                                          className="pdf-show"
                                          sx={{ display: "none !important" }}
                                        >
                                          {dates.join(", ")}
                                        </Box>
                                      </>
                                    );
                                  })()
                                ) : (
                                  "-"
                                )}
                              </Cell>
                              <Cell>
                                
                                {/* <ListCell
                                  values={
                                    Array.isArray(item?.org_credentials)
                                      ? item.org_credentials.map((c) => c?.master_email)
                                      : []
                                  }
                                  limit={2}
                                /> */}

                                {item?.master_email ?? '-'}
                              </Cell>
                              <Cell>
                                <ListCell
                                  values={
                                    Array.isArray(item?.org_credentials)
                                      ? item.org_credentials.map(c => getAuctionName?.(c?.auction_house?.name) ?? c?.auction_id)
                                      : []
                                  }
                                />
                              </Cell>
                              <Cell>

                                <ListCell
                                  values={
                                    Array.isArray(item?.org_credentials)
                                      ? item.org_credentials.map((c) => c?.master_id)
                                      : []
                                  }
                                  limit={2}
                                />
                              </Cell>
                              <Cell>{item?.remarks ?? "-"}</Cell>
                              <Cell>{item?.status ?? "-"}</Cell>
                              <Cell>

                                {Array.isArray(item?.id_types) && item.id_types.some(d => d?.document_link) ? (
                                  // <Tooltip title="Download all attachments" arrow>
                                    <div
                                    style={{ cursor: "pointer" }}
                                      onClick={() => downloadAllDocs(item.id_types)}
                                    >
                                      <FiDownload color={Colors.primary} />
                                    </div>
                                  // </Tooltip>
                                ) : (
                                  <div disabled>
                                    <FiDownload color="gray" />
                                  </div>

                                )}

                              </Cell>
                              <Cell>{<IconButton
                                size="small"
                                onClick={() => navigate(`/update-company/${item?.id}`)}
                              >
                                <Edit sx={{ color: Colors.primary }} />
                              </IconButton>}</Cell>
                            </Row>
                          ))}
                        </Fragment>
                      </>
                    ) : (
                      <Row>
                        <Cell
                          colSpan={tableHead.length + 1}
                          align="center"
                          sx={{ fontWeight: 600 }}
                        >
                          No Data Found
                        </Cell>
                      </Row>
                    )
                  ) : (
                    <Row>
                      <Cell
                        colSpan={tableHead.length + 2}
                        align="center"
                        sx={{ fontWeight: 600 }}
                      >
                        <Box className={classes.loaderWrap}>
                          <CircularProgress />
                        </Box>
                      </Cell>
                    </Row>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {/* </PDFExport> */}
            <Grid item md={12} mb={3}>
              <Pagination
                currentPage={currentPage}
                pageSize={pageLimit}
                onPageSizeChange={(size) => getCompanyData(1, size.target.value)}
                tableCount={companyData?.length}
                totalCount={totalCount}
                onPageChange={(page) => getCompanyData(page, "")}
              />
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default CompanyList;
